module.exports = __webpack_public_path__ + "img/月亮日記排序.f79332c3.svg";